import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export interface Fondsskole {
	step: string;
}

export interface FondsskoleState {
	stepsCompleted: Fondsskole[];
}

const defaultState: FondsskoleState = {
	stepsCompleted: [],
};

export default function fondsskoleReducer(state = defaultState, action: Action): FondsskoleState {
	const { step } = action.data || {};

	switch (action.type) {
		case actions.STEP_COMPLETED:
			if (!state.stepsCompleted.some((s) => s.step === step)) {
				return {
					...state,
					stepsCompleted: [...state.stepsCompleted, { step }],
				};
			}
			return state;
		default:
			return state;
	}
}
